<template>
    <div>
        <ui-modal ref="saveDataViewModal" :title="savedViewId ? 'Custom View Options' : 'Save Custom View'" @hide="reset" dismiss-on="close-button esc">
            <div class="container-fluid" style="padding: 0; margin-top: 1rem;">
                <div class="row">
                    <div class="col-12">
                        <ui-textbox label="Name" v-model="name" :max="255" :enforce-maxlength="true"></ui-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <ui-checkbox label="Set as default view" v-model="isDefault" @change="setSharing"></ui-checkbox>
                    </div>
                    <div class="col-6">
                        <ui-checkbox :disabled="isDefault" label="Share with team" v-model="shareWithTeam"></ui-checkbox>
                    </div>
                </div>
            </div>

            <div slot="footer" style="width: 100%; text-align: right;">
                <ui-progress-circular v-show="isLoading" style="float:left;"></ui-progress-circular>
                <button :disabled="isLoading" class="btn btn-primary" @click="save">Save</button>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'

    export default {
        data() {
            return {
                name: '',
                savedViewId: null,
                shareWithTeam: false,
                isDefault: false,
                isLoading: false,
            }
        },
        computed: {
            ...mapState({
                savedViews: state => state.dataView.savedViews
            })
        },
        methods: {
            ...mapActions({
                saveView: 'dataView/save',
            }),
            setSharing($e) {
                if ($e) {
                    this.shareWithTeam = false
                }
            },
            reset() {
                this.name = '';
                this.savedViewId = null;
                this.shareWithTeam = false;
                this.isDefault = false;
                this.isLoading = false;
            },
            open(savedDataViewId = null) {
                this.reset();

                if (savedDataViewId) {
                    let view = this.savedViews.find(item => {
                        return item.id === parseInt(savedDataViewId)
                    })

                    if (view) {
                        this.name = view.name
                        this.shareWithTeam = !view.is_private
                        this.isDefault = view.is_default
                        this.savedViewId = view.id
                    }
                }

                this.$refs['saveDataViewModal'].open();
            },
            save() {
                this.isLoading = true;

                let attr = { 
                    id: this.savedViewId,
                    name: this.name, 
                    is_private: this.isPrivate || this.isDefault,
                    is_default: this.isDefault,
                };

                this.saveView(attr).then(response => {
                    this.isLoading = false;

                    this.$refs['saveDataViewModal'].close()
                }, error => {
                    this.isLoading = false;
                });
            }
        }
    }
</script>